export default function isAntiFraudIdFailed(identificationCheck) {
  const formattedDetails = identificationCheck.formattedDetails;

  if (!formattedDetails) {
    return false;
  }

  return formattedDetails.identification_verification_string === "Fail";
}
